"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Articles = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ionSections = require("ion-sections");
var _qs = _interopRequireDefault(require("qs"));
var _reactHelmet = _interopRequireDefault(require("react-helmet"));
var _ionArticle = _interopRequireDefault(require("ion-article"));
var _ionIcon = require("ion-icon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Articles = /*#__PURE__*/function (_Component) {
  _inherits(Articles, _Component);
  var _super = _createSuper(Articles);
  function Articles(props) {
    var _this;
    _classCallCheck(this, Articles);
    _this = _super.call(this);
    _this.page = 0;
    _this.windowWidth = 0;
    _this.handleViewMore = _this.handleViewMore.bind(_assertThisInitialized(_this));

    // Fetch the first time this component is mounted
    var data = props.articles && props.section in props.articles ? props.articles[props.section] : false;
    var lastFetch = new Date(data ? data.lastFetch || 0 : 0);
    var now = new Date();
    var params = props.location ? _qs["default"].parse(props.location.search, {
      ignoreQueryPrefix: true
    }) : {
      page: 0
    };
    var startIndex = Math.max((props.index || 0) - 1, 0);
    _this.page = params.page || 1;
    var startPage = Math.max(_this.page - 1, 1);
    if (props.withMore && _this.page > 1) {
      var page0Limit = props.page0Limit || props.pageSize;
      // console.log('componentWillMount(1)', props.section, startIndex, pageSize)
      props.fetchArticles(props.section, page0Limit + (startPage - 1) * props.pageSize, props.pageSize, props.filter);
    } else if (!data || !data.articles || data.lastFetch && now - lastFetch > 60000 * 15 || data.articles.length < props.pageSize) {
      var pageSize = Math.max(props.pageSize || 0, props.count || 0);
      // console.log('componentWillMount', 'section:', props.section, 'data:', data)
      props.fetchArticles(props.section, 0, startIndex + pageSize, props.filter);
    }
    return _this;
  }
  _createClass(Articles, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var data = this.props.articles && this.props.section in this.props.articles ? this.props.articles[this.props.section] : false;
      // Re-fetch articles when the section changes
      var startIndex = Math.max((this.props.index || 0) - 1, 0);
      if (prevProps.section !== this.props.section) {
        var pageSize = Math.max(this.props.pageSize || 0, this.props.count || 0);
        if (!data || data.articles.length < this.props.pageSize) {
          console.log('componentDidUpdate(1)', this.props.section, startIndex, pageSize);
          this.props.fetchArticles(this.props.section, 0, startIndex + pageSize, this.props.filter);
        }
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (nextProps.section === this.props.section && nextProps.withReadCount === this.props.withReadCount && nextProps.extraState === this.props.extraState) {
        var section = nextProps.section;
        var data = this.props.articles && section in this.props.articles ? this.props.articles[section] : false;
        var newdata = nextProps.articles && section in nextProps.articles ? nextProps.articles[section] : false;
        if (JSON.stringify(data) === JSON.stringify(newdata)) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "handleViewMore",
    value: function handleViewMore() {
      var initialArticles = Math.max(this.props.index - 1, 0) + this.props.count;
      var alreadyFetchedArticles = Math.max(this.page - 1, 0) * this.props.pageSize;
      this.props.fetchMoreArticles(this.props.section, initialArticles + alreadyFetchedArticles, this.props.pageSize);
      this.page++;
    }
  }, {
    key: "render",
    value: function render() {
      var sectionProps = {
        hasError: false
      };
      var moreButtonColour = this.props.moreButtonColour ? ' ' + this.props.moreButtonColour : '';
      if (this.props.articles && this.props.articles[this.props.section]) {
        sectionProps = this.props.articles[this.props.section];
      }
      if (sectionProps.hasError) {
        if (this.props.isConnected) {
          if (sectionProps.is404) {
            if (this.props.notFound) {
              return /*#__PURE__*/_react["default"].createElement(this.props.notFound, this.props);
            }
            return /*#__PURE__*/_react["default"].createElement("div", null, "No articles found and no ", /*#__PURE__*/_react["default"].createElement("i", null, "notFound"), " property specified");
          }
          // TODO: Use a template to allow site / section specific formatting and wording.
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", null, "ERROR"), /*#__PURE__*/_react["default"].createElement("pre", null, sectionProps.error));
        }
        // TODO: Use a template to allow site / section specific formatting and wording.
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h2", null, "Offline"), /*#__PURE__*/_react["default"].createElement("div", null, "This section is not currently available in your cache. Please go back online and we'll fetch the latest in this section"));
      }
      var Loading = this.props.loading || function (_ref) {
        var section = _ref.section;
        return /*#__PURE__*/_react["default"].createElement("div", null, "Loading ", section, "...");
      };
      if (!this.props.withMore && sectionProps.isFetching) {
        return /*#__PURE__*/_react["default"].createElement(Loading, {
          section: (0, _ionSections.getSectionLabel)(this.props.section)
        });
      } else if (sectionProps.hasFetched || sectionProps.isFetching) {
        if (sectionProps.articles && sectionProps.articles.length < this.props.pageSize && this.props.withMore && this.props.hasMore) {
          // The TVBox should render the skeleton until the section articles are fetched.
          return /*#__PURE__*/_react["default"].createElement(Loading, {
            section: (0, _ionSections.getSectionLabel)(this.props.section)
          });
        }
        var data = sectionProps;
        if (data && data.articles && data.articles.length) {
          var pageNumber = parseInt(this.page, 10);
          var nextHref = this.props.match ? this.props.match.url + '?page=' + (pageNumber + 1) : '';
          var prevHref = this.props.match ? this.props.match.url + '?page=' + (pageNumber - 1) : '';
          var boundedIndex = Math.max((this.props.index || 1) - 1, 0);
          var index = boundedIndex;
          var count = this.props.count || this.props.pageSize;
          var articles = this.props.withMore ? data.articles.map(function (article) {
            return new _ionArticle["default"](article);
          }) : data.articles.slice(0, this.props.pageSize).map(function (article) {
            return new _ionArticle["default"](article);
          });
          var MoreButton = false;
          if (this.props.withMore && data.hasMore) {
            if (this.props.isConnected) {
              if (this.props.moreButton) {
                MoreButton = /*#__PURE__*/_react["default"].createElement(this.props.moreButton, {
                  loading: sectionProps.isFetching,
                  onClick: this.handleViewMore,
                  sectionProps: sectionProps,
                  nextHref: nextHref,
                  pageNumber: pageNumber,
                  prevHref: pageNumber > 1 ? prevHref : false,
                  canonical: process.env.RAZZLE_SITE_URL + this.props.location.pathname,
                  moreButtonColour: moreButtonColour
                });
              } else {
                MoreButton = /*#__PURE__*/_react["default"].createElement("div", {
                  id: "buttonContainer",
                  className: "more-from-btn noScript small-12 medium-12"
                }, typeof window !== 'undefined' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
                  className: 'btn' + moreButtonColour,
                  id: "viewMoreButton",
                  onClick: this.handleViewMore
                }, " View More")), typeof window === 'undefined' && /*#__PURE__*/_react["default"].createElement("a", {
                  id: "viewMoreButtonNoScript",
                  href: nextHref
                }, /*#__PURE__*/_react["default"].createElement("button", null, "View More")), /*#__PURE__*/_react["default"].createElement(_reactHelmet["default"], null, /*#__PURE__*/_react["default"].createElement("link", {
                  rel: "canonical",
                  itemprop: "url",
                  href: process.env.RAZZLE_SITE_URL + this.props.location.pathname
                }), /*#__PURE__*/_react["default"].createElement("link", {
                  rel: "next",
                  href: nextHref
                }), pageNumber > 1 && /*#__PURE__*/_react["default"].createElement("link", {
                  rel: "prev",
                  href: prevHref
                })));
              }
            } else {
              MoreButton = /*#__PURE__*/_react["default"].createElement("div", {
                id: "buttonContainer",
                className: "offline"
              }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_ionIcon.Warn, {
                width: "24",
                height: "24"
              }), "You are currently offline. To see more articles, please re-establish your internet connection."));
            }
          }
          var ArticlesTemplate = this.props.component || function (_ref2) {
            var articles = _ref2.articles;
            return /*#__PURE__*/_react["default"].createElement("ul", null, articles.map(function (article) {
              return /*#__PURE__*/_react["default"].createElement("li", {
                key: article.contentKey
              }, article.headline);
            }));
          };
          var sectionLabel = this.props.sectionLabel;
          if (!sectionLabel) {
            if (data.sectionLabel) {
              sectionLabel = data.sectionLabel;
            } else if (data.sectionsLabels && data.sectionsLabels.length) {
              sectionLabel = data.sectionsLabels[0].label;
            }
          }
          if (this.props.noDiv) {
            return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(ArticlesTemplate, _extends({}, this.props, {
              articles: articles.slice(index, this.props.withMore ? articles.length : index + count),
              section: this.props.section,
              noImage: this.props.noImage,
              authorName: data.authorName,
              sectionLabel: sectionLabel,
              sectionsLabels: data.sectionsLabels,
              moreButton: MoreButton,
              relatedSections: this.props.relatedSections
            })), this.props.children);
          }
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: this.props.className
          }, /*#__PURE__*/_react["default"].createElement(ArticlesTemplate, _extends({}, this.props, {
            articles: articles.slice(index, this.props.withMore ? articles.length : index + count),
            section: this.props.section,
            noImage: this.props.noImage,
            authorName: data.authorName,
            sectionLabel: sectionLabel,
            sectionsLabels: data.sectionsLabels,
            moreButton: MoreButton,
            relatedSections: this.props.relatedSections
          })), this.props.children);
        } else {
          if (!sectionProps.isFetching) {
            // console.debug('No data', sectionProps.isFetching)
            if (this.props.notFound) {
              return /*#__PURE__*/_react["default"].createElement(this.props.notFound, this.props);
            }
            return /*#__PURE__*/_react["default"].createElement("div", null, "No articles found and no ", /*#__PURE__*/_react["default"].createElement("i", null, "notFound"), " property specified");
          }
          var _Loading = this.props.loading || function (_ref3) {
            var section = _ref3.section;
            return /*#__PURE__*/_react["default"].createElement("div", {
              className: "wrapper"
            }, "Loading ", section, "...");
          };
          return /*#__PURE__*/_react["default"].createElement(_Loading, {
            section: (0, _ionSections.getSectionLabel)(this.props.section)
          });
        }
      } else {
        var _Loading2 = this.props.loading || function (_ref4) {
          var section = _ref4.section;
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "wrapper"
          }, "Loading ", section, "...");
        };
        return /*#__PURE__*/_react["default"].createElement(_Loading2, {
          section: (0, _ionSections.getSectionLabel)(this.props.section)
        });
      }
    }
  }]);
  return Articles;
}(_react.Component);
exports.Articles = Articles;
Articles.propTypes = {
  fetchArticles: _propTypes["default"].func.isRequired,
  fetchMoreArticles: _propTypes["default"].func.isRequired,
  pageSize: _propTypes["default"].number,
  withMore: _propTypes["default"].bool.isRequired,
  noImage: _propTypes["default"].string.isRequired,
  section: _propTypes["default"].string.isRequired,
  articles: _propTypes["default"].object.isRequired
};
Articles.defaultProps = {
  index: 0,
  skip: 0,
  pageSize: 16,
  withMore: false,
  section: 'news',
  className: 'article-list'
  // articles: {}
};
var _default = Articles;
exports["default"] = _default;